$.fn.navigation = function (options) {
  	'use strict';

  	var _elem         = $(this),  // instance to $('#selector')
      	_this         = this,     // instance to this plugin
        _browserWidth = $(window).width();

  	// custom variables
  	var o = $.extend({
        openAnimation: 'slide down', // can be either 'drop', 'slide down', 'scale', 'swing down' etc. More can be found in the docs of Semantic UI.
        breakpoint: 992,
        mobileToggle: '.mobile-nav-toggle button'
  	}, options);

    $(window).on('resize', function() {
        _browserWidth = $(window).width();

        // init desktop subnav if above breakpoint setting
        _this.initDesktopSubnav();

        // init mobile subnav if below breakpoint setting
        _this.initMobileNav();
    });

  	_this.init = function () {
        _browserWidth = $(window).width();

        // append backdrop
        $('#backdrop').remove();
        $('body').append('<div id="backdrop"></div>');

        // init desktop subnav if above breakpoint setting
        _this.initDesktopSubnav();

        // init mobile subnav if below breakpoint setting
        _this.initMobileNav();
  	};

    _this.initMobileNav = function() {
        if (_browserWidth < o.breakpoint)
        {
            if (!_elem.hasClass('mobile-nav-attached'))
            {
                // init mobile navigation
                _this.AttachMobileNavigationHandlers();
            }
        }
        else
        {
            // destroy mobile navigation
            _this.RemoveMobileNavigationHandlers();
        }
    };


    // create mobile navigation
    _this.AttachMobileNavigationHandlers = function() {
        _elem.addClass('mobile-nav-attached');

        $(document).on('click', o.mobileToggle, function() {
            if (!_elem.hasClass('mobile-visible'))
            {
                _this.OpenMobileNavigation();
            }
            else
            {
                _this.CloseMobileNavigation();
            }
        });

        $(document).on('click.backdrop', '#backdrop', function() {
            _this.CloseMobileNavigation();
        });
        
        _elem.find('.fa.mobile-subnav-trigger').on('click', function() {
            $(this).toggleClass('subnav-visible');

            $(this).siblings('ul.sub-menu').stop(true, false).slideToggle(300);
        });
    };

    // close navigation
    _this.CloseMobileNavigation = function() {
        _elem.removeClass('mobile-visible');
        $(o.mobileToggle).removeClass('mobile-visible');
        $('#backdrop').removeClass('backdrop-visible');
    };

    // open navigation
    _this.OpenMobileNavigation = function() {
        _elem.addClass('mobile-visible');
        $(o.mobileToggle).addClass('mobile-visible');
        $('#backdrop').addClass('backdrop-visible');
    };

    // destroy mobile navigation
    _this.RemoveMobileNavigationHandlers = function() {
        _elem.removeClass('mobile-nav-attached mobile-visible');
        $('#backdrop').removeClass('backdrop-visible');
        $(o.mobileToggle).removeClass('mobile-visible');
        //$('ul.sub-menu').css('display', 'none');
        $('.fa.mobile-subnav-trigger').removeClass('subnav-visible');

        _elem.find('.fa.mobile-subnav-trigger').off();
        $(o.mobileToggle).off();
        $(document).off('click.backdrop');
    };



    // init desktop subnav if above breakpoint setting
    _this.initDesktopSubnav = function() {
        if (_browserWidth >= o.breakpoint)
        {
            if (!_elem.hasClass('desktop-subnav-attached'))
                _this.AttachSubNavigationHandlers();
        }
        else
        {
            _this.RemoveSubNavigationHandlers();
        }
    };

// create desktop submenu on hover
    _this.AttachSubNavigationHandlers = function() {
        _elem.addClass('desktop-subnav-attached');

        $('#navigation .navigation-wrapper > ul li').each(function() {
            var firstLevel      = $(this);
            var firstSubMenu    = $(this).find('> ul');

            // show if not visible
            firstLevel.on('mouseenter', function() {
                firstSubMenu.transition('stop all').transition('clear queue').transition(o.openAnimation);
                // hide if visible after timeout setting seconds
            }).on('mouseleave', function() {
                if (firstSubMenu.hasClass('visible') || firstSubMenu.hasClass('animating'))
                    firstSubMenu.transition('stop all').transition('clear queue').transition(o.openAnimation);
            });
        });
    };

    // destroy desktop submenu on hover
    _this.RemoveSubNavigationHandlers = function() {
        _elem.removeClass('desktop-subnav-attached');

        $('#navigation > ul li').each(function() {
            var firstLevel      = $(this);

            firstLevel.off();

            $('.sub-menu').removeClass('transition hidden');
        });
    };


  	_this.init();
};